(function (upp) {
    'use strict';

    upp.service('translator', ['tmhDynamicLocale',
        function (tmhDynamicLocale) {

            var DEF_LANG = 'es',
                allTranslations = translations,
                defTranslations,
                currentTranslations,
                currentParentTranslations = {},
                currentLang,
                currentParentLang;

            /**
             *
             * Returns the language code of the user:, in this order
             - language (non-IE, browser install language)
             - browserLanguage (IE, browser install language)
             - userLanguage (IE, user-level OS-wide language setting)
             *
             * @method detectUserLanguage
             * @returns {string} String code of the user language
             * @private
             */
            var _detectUserLanguage = function () {
                return (window.navigator.languages &&  window.navigator.languages[0])
                    || window.navigator.language
                    || window.navigator.browserLanguage
                    || window.navigator.userLanguage;
            };

            /**
             * Init the translator (set default translation data, set up default locale), optionally, with a different default locale
             *
             * @method initLang
             * @param {String} lang Default locale
             * @return {void}
             * @private
             */
            var _initLang = function (lang) {
                DEF_LANG = lang || DEF_LANG;
                defTranslations = allTranslations[DEF_LANG] || {};
                setLang(DEF_LANG);
            };

            /**
             * Change the current language of the translator
             *
             * @method setLang
             * @param {String} lang Locale to be set
             * @return {void}
             */
            var setLang = function () {
                var setCurrentLang = function (lang, parentLang) {
                    var parentTranslation;

                    currentParentLang = undefined;
                    currentParentTranslations = {};

                    if (currentTranslations = allTranslations[lang]) {
                        currentLang = lang;
                        if (parentLang && (parentTranslation = allTranslations[parentLang])) {
                            currentParentLang = parentLang;
                            currentParentTranslations = parentTranslation;
                        }
                    } else {
                        // If there is not new lang translations (undefined)
                        if (parentLang) {
                            // if parent translation available
                            // set current to parent translations
                            currentTranslations = allTranslations[parentLang];
                            currentLang = parentLang;
                        } else {
                            // set default translations
                            currentTranslations = defTranslations;
                            currentLang = DEF_LANG;
                        }
                    }
                };

                var setAngularLocaleLang = function (lang, parentLang) {
                    // FIXME: if language is 'es-MX', library 'tmhDynamicLocale' only retrieves file 'locale_es-mx.js' but,
                    // if that file doesn't exist, should try to retrieve 'locale_es.js', but it doesn't.
                    // So, to solve this, firstly 'locale_es.js' is explicitly loaded, and then 'locale_es-mx.js'
                    if (parentLang) {
                        tmhDynamicLocale.set(parentLang.toLocaleLowerCase());
                    }
                    tmhDynamicLocale.set(lang.toLocaleLowerCase());
                };

                return function (lang) {
                    var parentLang;

                    if (lang) {
                        var langCodes = [];
                        for (var l in allTranslations) {
                            if (allTranslations.hasOwnProperty(l)) {
                                langCodes.push(l);
                            }
                        }

                        if (_isSublang(lang)) {
                            parentLang = _getLangOfSublang(lang);
                        }

                        if (langCodes.indexOf(parentLang || lang) < 0) {
                            lang = DEF_LANG;
                        }
                        setCurrentLang(lang, parentLang);
                        setAngularLocaleLang(lang, parentLang);
                    } else {
                        throw new Error("not lang");
                    }
                }
            }();

            /**
             * Return the current locale code
             *
             * @method getLang
             * @return {String} Current locale code
             */
            var getLang = function () {
                return currentLang;
            };

            /**
             *
             * Transforms an input string like 'param {0} is {1}' and an array of string like ['AA,'BB'] to an output string like 'param AA is BB'
             *
             * @method regExpTranslate
             * @param toTranslate {String}
             * @param dynamicParams {[String]}
             * @returns {String}
             * @private
             */
            var _regExpTranslate = function (toTranslate, dynamicParams) {
                return toTranslate.replace(/\{(\w+)\}/g, function (s, key) {
                    var value = dynamicParams[key];
                    return value != undefined && value.toString().length > 0 ? value : s;
                });
            };

            /**
             * Translate to the current configured language an input key
             *
             * @method i18n
             * @param {String} input Key to be translated
             * @param {Array} extraParams Dynamic params to be included in the translation
             * @param {Boolean} pluralize If translation should be pluralized
             * @return {String} Translated string
             */
            var i18n = function (input, extraParams, pluralize) {
                var translated = currentTranslations[input] || currentParentTranslations[input] || defTranslations[input] || input;

                if (pluralize && extraParams && typeof extraParams[0] === 'number') {
                    translated = pluralizeI18n(input, extraParams[0]);
                } else if (extraParams) {
                    translated = _regExpTranslate(translated, extraParams);
                }

                return translated;
            };

            /**
             * Translate and pluralize to the current configured language an input key
             *
             * @method pluralizeI18n
             * @param {String} input Key to be translated
             * @param {Number} amount Amount to pluralize the key
             * @return {String} Translated string
             */
            var pluralizeI18n = function (input, amount) {
                var translated = input;

                if (typeof amount === 'number') {
                    var tmpInput = input + "(" + amount + ")",
                        toTranslate = currentTranslations[tmpInput] ||
                            currentParentTranslations[tmpInput] ||
                            defTranslations[tmpInput] ||
                            currentTranslations[input] ||
                            currentParentTranslations[input] ||
                            defTranslations[input] ||
                            input;

                    translated = _regExpTranslate(toTranslate, [amount]);
                }

                return translated;
            };

            var _splitSublang = function (sublang) {
                return sublang.split('-');
            };

            /**
             * Determines if a language code represents a sublanguage (Ex.: 'es' -> false, 'es-ES', true)
             *
             * @method isSublang
             * @param sublang {String}
             * @return {Boolean} true if sublang
             * @private
             */
            var _isSublang = function (sublang) {
                var codes = _splitSublang(sublang);
                return sublang && codes.length == 2 && codes[0].length > 0 && codes[1].length > 0;
            };

            /**
             * Returns lang code of the sublang (Ex.: 'es-ES'-> 'es')
             *
             * @param {String} sublang
             * @return {String}
             * @private
             */
            var _getLangOfSublang = function (sublang) {
                var codes = _splitSublang(sublang);
                return codes && codes[0];
            };

            _initLang();
            setLang(_detectUserLanguage());

            return {
                //Exposed for testing
                _initLang: _initLang,
                _detectUserLanguage: _detectUserLanguage,
                _isSublang: _isSublang,
                _getLangOfSublang: _getLangOfSublang,

                //Public
                setLang: setLang,
                getLang: getLang,
                i18n: i18n,
                pluralizeI18n: pluralizeI18n
            }
        }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/common/services/translator-service.js